// eslint-disable-next-line
import React from "react";

const dateObject = new Date();
const monthValue = dateObject.getMonth();
export const getCurrentIntakeMonth = () => {
    return monthValue > 7 ? 'January' : monthValue > 2 ? 'September' : 'April';
};
export const getCurrentIntakeYear = () => {
    return monthValue > 7 ? dateObject.getFullYear() + 1 : dateObject.getFullYear();
};
export const getCurrentIntakeQuery = () => {
    return `intake = '${getCurrentIntakeMonth()}' AND intake_year = '${getCurrentIntakeYear()}'`;
};